module.exports = __webpack_public_path__ + "img/bom8.f731295d.png";